import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { OfflineIndicator } from './OfflineIndicator';
import { GpsTracker } from './GpsTracker';

export const Layout = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="spinner" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="min-h-screen bg-background">
            <Sidebar />
            <MobileNav />
            <main className="md:ml-64 min-h-screen pb-20 md:pb-0">
                <Outlet />
            </main>
            <OfflineIndicator />
            <GpsTracker />
        </div>
    );
};

export default Layout;
